export default __webpack_public_path__ + "static/media/Ritual.14dde695.gif";